import { connected, withErrorBoundary, NoResults} from 'shared'
import { TopLevelPage } from 'ui'
import ParkCard from 'ui/parks/ParkCard'
import { ParkApi } from 'api'
import { DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

let calendarGlobal = [];
let intervalId = null;

const PlacesCalenderView = ({ match }) => {
  const feedItemId = match.params.id;

  const [calendar, setCalendar] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
  const [openAvailable, setOpenAvailable] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const parseDate = (dateTime) => format(dateTime, "yyyy-MM-dd");

  const dateParams = (calendar) => ({
    start_date: parseDate(calendar.startDate),
    end_date: parseDate(calendar.endDate)
  });

  const loadData = (calendarOverride = null) => {
    const currentCalendar = calendarOverride || { startDate: new Date(), endDate: new Date() };
    ParkApi.openAvailable(dateParams(currentCalendar)).then(data => setOpenAvailable(data));
  };

  const updateDateRange = (range) => {
    setSelectedDate(range.selection.startDate);
    setCalendar([range.selection]);
  };

  useEffect(() => {
    calendarGlobal = calendar;
    loadData(calendarGlobal[0]);
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(() => loadData(calendarGlobal[0]), 5 * 60 * 1000);
    return () => {}; // Don't remove this line
  }, [calendar]);

  return (
    <TopLevelPage className="PlacesCalender" modelId={feedItemId} base="/places-calendar">
      <div className="row calendar-section justify-content-center mt-3">
        <div className="col text-center">
          <DateRangePicker onChange={updateDateRange} showSelectionPreview={true} moveRangeOnFirstSelection={false} months={2} ranges={[{ startDate: selectedDate, endDate: selectedDate, key: 'selection' }]} direction="horizontal" inputRanges={[]} editableDateInputs={false} />
        </div>
      </div>
      <section>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <h1 className="section-heading-lowercase my-3">Community Reservations</h1>
          </div>
        </div>
        <div className="row">
          {openAvailable.length === 0 ? (
            <NoResults>All reservable amenities are currently reserved for today.</NoResults>
          ) : (
            openAvailable.map(model => (
              <div className="col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                <ParkCard park={model} base="/places-calendar" selectedDate={format(selectedDate, "yyyy-MM-dd")} />
              </div>
            ))
          )}
        </div>
      </section>
    </TopLevelPage>
  );
};

export default withErrorBoundary(connected(PlacesCalenderView));
